import { OnInit, Component } from "@angular/core";
import { StudyReportWizardService } from "../../../services/wizard/study-report/study-report.wizard.service";

@Component({
  selector: 'study-report-clinic-history-component',
  templateUrl: './study-report-clinic-history.component.html',
  styleUrls: ['./study-report-clinic-history.component.css']
})
export class StudyReportClinicHistoryComponent implements OnInit {

  patientId: number;
  constructor(private studyReportWizardService: StudyReportWizardService) {
    this.patientId = this.studyReportWizardService.patientId;
  }

  ngOnInit() {

  }


}
